import React, { ReactNode } from 'react';
import { Row } from './layout/Row';
import { IntlShape, useIntl } from 'react-intl';
import { ExternalIdDTO, WorkPersonOtherDTO } from '../../../api/core';
import { getNotation } from '../../../Vocabulary/util';
import { External } from '../../edit/components/LinkedPerson';
import { ExternalId } from './ExternalId';

interface Props {
  linkedPersons: External[];
  rolesListSubset?: string;
}

export const LinkedPersonOther: React.FC<Props> = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <Row title={intl.formatMessage({ id: 'work.attr.personsOther.label' })}>
      {props.linkedPersons
        .sort((a: WorkPersonOtherDTO, b: WorkPersonOtherDTO): number => a.sequence - b.sequence)
        .map(
          (person: WorkPersonOtherDTO, index: number): ReactNode => (
            <div key={index} className={'flex flex-column'}>
              <div>
                <strong>{[person.surname, person.givenname].filter(Boolean).join(', ')}</strong>
              </div>
              {person.externalIds && person.externalIds.length > 0 && (
                <div className={'flex'}>
                  {person.externalIds.map(
                    (externalId: ExternalIdDTO, idIndex: number): ReactNode => (
                      <div key={idIndex}>
                        <ExternalId id={externalId} entity={'person'} />
                      </div>
                    )
                  )}
                </div>
              )}
              <div>{`${intl.formatMessage({ id: 'work.attr.person.attr.role.label' })}: ${getNotation('person_role_list', person.role, intl.locale, props.rolesListSubset)}`}</div>
              <div>{`${intl.formatMessage({ id: 'work.attr.person.attr.sequence.label' })}: ${person.sequence}`}</div>
            </div>
          )
        )}
    </Row>
  );
}
